<template>
  <div class="coupon-apply">
    <img
      class="coupon-apply__logo"
      src="https://cdn-image.bestdealer.com/app-bestdealer/1688/coupon/sale.png"
      alt="sale logo"
    >
    <div class="coupon-apply__content">
      <p class="coupon-apply__text">
        Apply Discount at <span class="coupon-apply__hint">US$200</span>
      </p>
      <p
        class="coupon-apply__text coupon-apply__button"
        @click="intercom.showNewMessage()"
      >
        Apply Now
        <SvgIcon
          class="coupon-apply__arrow"
          :svg="rightArrowSvg"
          color="#232323"
          width="10px"
          height="10px"
        />
      </p>
    </div>
  </div>
</template>

<script setup>
import rightArrowSvg from '@/assets/offer/right-arrow.svg?raw'
import { useIntercom } from '@/hooks/useIntercom'

const intercom = useIntercom()
</script>

<style lang="less" scoped>
.coupon-apply {
  padding: 0 12px;
  background-color: #DFE8FB;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px 8px 0 0;
  box-sizing: content-box;
  height: 40px;

  @media (min-width: 1024px) {
    padding: 12px;
    border-radius: 4px;
  }

  &__logo {
    flex-shrink: 0;
    margin-top: 4px;
    width: 40px;
    height: 40px;
  }

  &__content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;

    @media (min-width: 1024px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__text {
    font-family: mon-600;
    font-size: 11px;
  }

  &__button {
    margin-left: auto;
    color: #232323;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #004F9A;
    }

    @media (min-width: 1024px) {
      margin-left: unset;
    }
  }

  &__hint {
    font-size: 14px;
    color: #F25776;
  }

  &__arrow {
    @media (min-width: 1024px) {
      display: none;
    }
  }
}
</style>
